import { BASE_URL } from '../apiConfig';
import { authFetch, handleAuthResponse } from '../../utils/authFetch';

export const validateUserAPI = async (payload) => {
  let options = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: "abc123",
      apikey: "abc123",
    },
    body: JSON.stringify(payload),
  };
  return await authFetch(
    `${BASE_URL}/validateUser`, 
    // "https://gzisg4fzzpgklhicwsp5vppnum0gbxei.lambda-url.ap-southeast-1.on.aws/validateuser",
    options
  ).then(handleAuthResponse);
};

export const getuserinfoAPI = async (payload) => {
  let options = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: "abc123",
      apikey: "abc123",
    },
    body: JSON.stringify(payload),
  };
  return await authFetch(
    `${BASE_URL}/getuserInfo`, 
    // "https://gzisg4fzzpgklhicwsp5vppnum0gbxei.lambda-url.ap-southeast-1.on.aws/getuserinfo",
    options
  ).then(handleAuthResponse);
};

export const fetchUserDetailsApi = async (payload) => {
  let options = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: "abc123",
      apikey: "abc123",
    },
    body: JSON.stringify(payload),
  };
  return await authFetch(
    `${BASE_URL}/getUserFullDetails`, 
    options
  ).then(handleAuthResponse);
};

export const updateUserLanguageAPI = async (languageAbbreviation) => {
  const authToken = localStorage.getItem("authToken");
  let options = {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
    },
    body: JSON.stringify({ languageAbbreviation }),
  };
  return await authFetch(
    `${BASE_URL}/updateUserLanguage`,
    options
  ).then(handleAuthResponse);
};

export const addFieldAPI = async (payload) => {
  const authToken = localStorage.getItem("authToken");
  let options = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
    },
    body: JSON.stringify(payload),
  };
  
  try {
    const response = await authFetch(`${BASE_URL}/addField`, options);
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    return await response.json();
  } catch (error) {
    console.error('Error in addFieldAPI:', error);
    throw error;
  }
};

export const getFieldAPI = async (payload) => {
  const authToken = localStorage.getItem("authToken");
  let options = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
    },
    body: JSON.stringify(payload),
  };
  
  try {
    const response = await authFetch(`${BASE_URL}/getField`, options);
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    return await response.json();
  } catch (error) {
    console.error('Error in getFieldAPI:', error);
    throw error;
  }
};

export const forgotPasswordAPI = async (payload) => {
  let options = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  };
  return await authFetch(
    `${BASE_URL}/api/forgotPassword`,
    options
  ).then(handleAuthResponse);
};

export const getEudrReportsAPI = async (accountId, fieldName) => {
  const authToken = localStorage.getItem("authToken");
  let options = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
    },
  };
  
  try {
    const url = fieldName 
      ? `${BASE_URL}/api/eudr/reports/${accountId}/${fieldName}`
      : `${BASE_URL}/api/eudr/reports/${accountId}`;
    const response = await authFetch(url, options);
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    return await response.json();
  } catch (error) {
    console.error('Error in getEudrReportsAPI:', error);
    throw error;
  }
};

export const verifyResetTokenAPI = async (token) => {
  let options = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  };
  return await authFetch(
    `${BASE_URL}/api/verifyResetToken/${token}`,
    options
  ).then(handleAuthResponse);
};

export const resetPasswordAPI = async (payload) => {
  let options = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  };
  return await authFetch(
    `${BASE_URL}/api/resetPassword`,
    options
  ).then(handleAuthResponse);
};